module.exports = __webpack_public_path__ + "2af48a1c81939939db41b9a3ceb8d4ba.svg";